import client from '../client-unauthenticated';

const buildId = async (): Promise<string> => {
  const { data } = await client.get<string>('/build-id');

  return data;
};

export default buildId;
